import { atom } from "jotai";

// Dernière timeline de l'agent chargée pour la carte (PER-2500), posée par
// l'onglet « Agent de tarification » et lue par la barre d'accès de la carte
// et les onglets du panneau : quand le déroulé montre plusieurs compagnies
// dans des états différents, la barre met une pastille par compagnie et le
// panneau dit « 2 compagnies » (ST1-2214 ; sans timeline, le résumé de la
// recherche `lead.agent.compagnies` joue le même rôle). Un atome par carte
// (chaque lead auto a son Provider jotai) ; null tant que rien n'est chargé.
export const agentTimelineAtom = atom(null);
